import { AfterViewChecked, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { DocumentNotesData } from '../../models/document-notes.model';
import { MatTableDataSource } from '@angular/material/table';
import { CommonService } from '../../services/common.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-view-workflow-notes',
  templateUrl: './view-workflow-notes.component.html',
  styleUrl: './view-workflow-notes.component.scss'
})
export class ViewWorkflowNotesComponent  implements OnInit, AfterViewChecked {

  displayedColumns: string[] = [
    'entryDate',
    'entryUsername',
    'entryUserFullName',
    'text'
  ];

  comment: any;
  dataSource: MatTableDataSource<DocumentNotesData>;
  hideSave:boolean = true;
  showSpinner: boolean = true;

  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly dialogRef: MatDialogRef<ViewWorkflowNotesComponent>,
    private readonly commonService: CommonService
  ) {
    this.dataSource = new MatTableDataSource<DocumentNotesData>([]);
  }
  ngOnInit():void {
    this.getNoteDetails();
  }
  getNoteDetails() : void {
    console.log("before load "+this.dataSource);
    if(this.data?.Type == "view"){
      this.hideSave = false;
    }
    this.showSpinner = true;
    if(this.data?.DocumentId){
      this.commonService.getWorkFlowNotesDetailsByInstanceorDocId(this.data?.userGpid, this.data?.systemId, this.data?.DocumentId).subscribe({
        next: (response: DocumentNotesData[]) => { 
          this.dataSource = new MatTableDataSource<DocumentNotesData>(response);
          this.showSpinner = false;
          console.log("after load "+ this.dataSource.data.length);
        },
        error: (error) => {
          this.showSpinner = true;
          console.error('Not able to fetch the document history:', error);
        }
    });
    }else{ 
      this.commonService.getWorkFlowNotesDetailsByBatchId(this.data?.userGpid, this.data?.systemId, this.data?.BatchId).subscribe({
        next: (response: DocumentNotesData[]) => { 
          this.dataSource = new MatTableDataSource<DocumentNotesData>(response);
          this.showSpinner = false;
          console.log("after load "+ this.dataSource.data.length);
        },
        error: (error) => {
          this.showSpinner = true;
          console.error('Not able to fetch the document history:', error);
        }
    });
    }
    
  }
  ngAfterViewChecked() {
    this.dataSource!.sort = this.sort;
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }
  onSaveComment() {
    if (this.comment && this.comment.length <= 2000) {
      let postObj = {Text: this.comment}
      this.showSpinner = true;
      this.commonService.addWorkflowNotes(this.data?.userGpid, this.data?.systemId, this.data?.items, postObj).subscribe({
        next: (response: boolean) =>{
          this.showSpinner = false;
          this.getNoteDetails();
          this.comment = "";
          this.commonService.showMessage("Notes added.","success");
        },
        error: (error: any) => {
          this.showSpinner = true;
          this.commonService.showMessage("Error in adding notes. " + error.error.message,"error");
          this.comment = "";
        }
    });
    }
  } 
}
